// In-memory access token store. The refresh token lives in an httpOnly
// cookie managed by the backend, so only the short-lived access token is
// kept here (lost on page reload, by design — refreshAccessToken restores it).
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:8000/api/v1";

let accessToken = null;

export const setAccessToken = (token) => {
  accessToken = token;
};

export const getAccessToken = () => accessToken;

export const clearAccessToken = () => {
  accessToken = null;
};

// Exchanges the refresh-token cookie for a new access token. Returns true on
// success. Concurrent callers share one in-flight request.
let refreshPromise = null;

export const refreshAccessToken = () => {
  if (!refreshPromise) {
    refreshPromise = fetch(`${BACKEND_URL}/refresh`, {
      method: "POST",
      credentials: "include",
    })
      .then(async (response) => {
        if (!response.ok) {
          clearAccessToken();
          return false;
        }
        const data = await response.json();
        setAccessToken(data.access_token);
        return true;
      })
      .catch(() => {
        clearAccessToken();
        return false;
      })
      .finally(() => {
        refreshPromise = null;
      });
  }
  return refreshPromise;
};

export const logout = async () => {
  try {
    await fetch(`${BACKEND_URL}/logout`, {
      method: "POST",
      credentials: "include",
    });
  } finally {
    clearAccessToken();
  }
};
